<template>
    <app-footer class="justify-content-end small flex items-center gap-6">
        <div v-if="termsOfUseLink">
            <a :href="termsOfUseLink" target="_blank">{{ trans('general.terms_of_use') }} </a>
        </div>
        <span v-if="termsOfUseLink" class="text-muted">|</span>
        <div>
            &copy; {{ new Date().getFullYear() }}
            Curie Technologies
        </div>
    </app-footer>
</template>

<script setup>
import AppFooter from '@/Components/AppFooter.vue';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

const page = usePage();
const termsOfUseLink = computed(() => page.props.termsOfUseLink);
</script>
